export default "__VITE_ASSET__DdonXr$___"